import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "318",
  "slug": "why-greenland-is-called-greenland",
  "title": "Why Is Greenland Called Greenland?",
  "excerpt": "The name comes from a Norse settlement story, not a description of the whole island.",
  "date": "2026-04-23",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800&q=80",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Greenland's name is associated with Erik the Red and Norse settlement in the late tenth century. In the saga tradition, an attractive name helped encourage settlers to follow him. Treat that explanation as a historical account transmitted through the sagas, rather than a recorded advertising campaign."
    },
    {
      "type": "paragraph",
      "text": "Visit Greenland's account places Erik's settlement at Brattahlið, now Qassiarsuk, in the southern fjords. Those coastal valleys can support green summer vegetation. The name does not describe the ice-covered interior."
    },
    {
      "type": "heading",
      "text": "Look at the place the name referred to"
    },
    {
      "type": "paragraph",
      "text": "Find Qassiarsuk on a map and compare its fjord setting with the interior ice sheet. A view of a southern valley and a view of the interior can both be Greenland while looking very different."
    },
    {
      "type": "paragraph",
      "text": "The story is often simplified into a joke about Greenland and Iceland having their names swapped. That shortcut loses the geographic context: neither island has a single surface or appearance throughout the year. A place name is a historical label, not a land-cover classification."
    }
  ],
  "sources": [
    {
      "title": "Visit Greenland: Erik the Red and the settlement account",
      "url": "https://visitgreenland.com/articles/erik-the-red/"
    }
  ],
  "relatedSlugs": [
    "why-greenland-looks-bigger-than-africa-on-maps"
  ]
};
